import React, { useState } from 'react';
import { construirCaption, publicarEnRedes } from '../services/publicarService';
import { obtenerFotos } from '../utils/categorias';
import { useToast } from '../context/ToastContext';
import { optimizarFoto } from '../utils/imagen';

// Modal (solo dueña) para publicar un producto del catálogo directo a
// Instagram y/o Facebook. Elige redes, edita el texto y publica.
export default function PublicarRedesModal({ producto, onCerrar }) {
  const { mostrarToast } = useToast();
  const [instagram, setInstagram] = useState(true);
  const [facebook, setFacebook] = useState(true);
  const [caption, setCaption] = useState(construirCaption(producto));
  const [publicando, setPublicando] = useState(false);
  const [resultado, setResultado] = useState(null); // { instagram?, facebook? }
  const [avisoConfig, setAvisoConfig] = useState(null);

  const fotos = obtenerFotos(producto);
  const redes = [instagram && 'instagram', facebook && 'facebook'].filter(Boolean);
  const puede = redes.length > 0 && caption.trim() && !publicando;

  const publicar = async () => {
    if (!puede) return;
    setPublicando(true);
    setResultado(null);
    setAvisoConfig(null);
    try {
      const data = await publicarEnRedes({ productoId: producto.id, redes, caption });
      setResultado(data.resultados || {});
      if (data.ok) mostrarToast('¡Publicado! 🎉', 'exito');
      else mostrarToast('No se pudo publicar. Revisa el detalle abajo.', 'error');
    } catch (e) {
      if (e.code === 'FALTA_TOKEN') {
        setAvisoConfig(e.message);
      } else {
        mostrarToast(e.message || 'No se pudo publicar', 'error');
      }
    } finally {
      setPublicando(false);
    }
  };

  const input = { width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };
  const chip = (activo) => ({
    display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px', borderRadius: '10px', cursor: 'pointer',
    border: `2px solid ${activo ? '#DB2777' : '#E5E7EB'}`, backgroundColor: activo ? '#FDF2F8' : 'white',
    fontWeight: 600, fontSize: '14px', color: activo ? '#DB2777' : '#6B7280', flex: 1, justifyContent: 'center',
  });

  const Estado = ({ red, r }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', borderRadius: '8px', backgroundColor: r.ok ? '#ECFDF5' : '#FEF2F2', fontSize: '13px' }}>
      <span>{r.ok ? '✅' : '⚠️'}</span>
      <span style={{ fontWeight: 600 }}>{red}:</span>
      <span style={{ color: r.ok ? '#065F46' : '#991B1B' }}>{r.ok ? 'Publicado' : (r.error || 'Falló')}</span>
    </div>
  );

  return (
    <div onClick={onCerrar} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 1300 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: 'white', borderRadius: '16px', width: '100%', maxWidth: '460px', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #F3F4F6', backgroundColor: '#FDF2F8', borderRadius: '16px 16px 0 0' }}>
          <h3 style={{ margin: 0, color: '#DB2777', fontSize: '18px' }}>📣 Publicar en redes</h3>
          <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#6B7280' }}>{producto.nombre}</p>
        </div>

        <div style={{ padding: '20px' }}>
          {fotos.length > 0 && (
            <>
              <img src={optimizarFoto(fotos[0], 800)} alt={producto.nombre} style={{ width: '100%', maxHeight: '360px', objectFit: 'contain', borderRadius: '12px', marginBottom: '8px', backgroundColor: '#F6F3FC' }} />
              {fotos.length > 1 && (
                <div style={{ display: 'flex', gap: '6px', marginBottom: '6px', overflowX: 'auto' }}>
                  {fotos.slice(1).map((f, i) => (
                    <img key={i} src={optimizarFoto(f, 120)} alt={`Foto ${i + 2}`} style={{ width: '54px', height: '54px', objectFit: 'cover', borderRadius: '8px', flex: '0 0 auto' }} />
                  ))}
                </div>
              )}
              <p style={{ margin: '0 0 14px', fontSize: '12px', color: '#6B7280' }}>
                {fotos.length === 1 ? 'Se publicará 1 foto' : `Se publicarán las ${fotos.length} fotos como carrusel`}
              </p>
            </>
          )}

          <label style={{ fontSize: '12px', color: '#6B7280', fontWeight: 600, display: 'block', marginBottom: '6px' }}>¿Dónde publicar?</label>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
            {[['Instagram', '📷', instagram, setInstagram], ['Facebook', '👍', facebook, setFacebook]].map(([nombre, icono, activo, cambiar]) => (
              <button key={nombre} type="button" role="checkbox" aria-checked={activo} disabled={publicando}
                style={{ ...chip(activo), fontFamily: 'inherit' }} onClick={() => cambiar((v) => !v)}>
                <span aria-hidden style={{ width: '20px', height: '20px', borderRadius: '6px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '14px', fontWeight: 800, color: 'white', background: activo ? '#DB2777' : 'white', border: `2px solid ${activo ? '#DB2777' : '#D1D5DB'}` }}>{activo ? '✓' : ''}</span>
                {icono} {nombre}
              </button>
            ))}
          </div>
          <p style={{ margin: '-8px 0 16px', fontSize: '13px', fontWeight: 600, color: redes.length ? '#9D174D' : '#B91C1C' }}>
            {redes.length ? `Se publicará en: ${redes.map((r) => (r === 'instagram' ? 'Instagram' : 'Facebook')).join(' y ')}` : 'Elige al menos una red'}
          </p>

          <label style={{ fontSize: '12px', color: '#6B7280', fontWeight: 600, display: 'block', marginBottom: '6px' }}>Texto de la publicación</label>
          <textarea value={caption} disabled={publicando} onChange={(e) => setCaption(e.target.value)}
            rows={9} style={{ ...input, resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.5 }} />

          {avisoConfig && (
            <div style={{ marginTop: '12px', padding: '10px 12px', backgroundColor: '#FEF9C3', borderRadius: '8px', fontSize: '13px', color: '#854D0E' }}>
              ⚙️ {avisoConfig}
            </div>
          )}

          {resultado && (
            <div style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {resultado.instagram && <Estado red="Instagram" r={resultado.instagram} />}
              {resultado.facebook && <Estado red="Facebook" r={resultado.facebook} />}
            </div>
          )}

          <div style={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
            <button onClick={onCerrar} disabled={publicando}
              style={{ flex: '0 0 auto', padding: '12px 18px', background: 'white', border: '1px solid #D1D5DB', borderRadius: '10px', cursor: 'pointer', color: '#6B7280', fontWeight: 600 }}>
              {resultado ? 'Cerrar' : 'Cancelar'}
            </button>
            <button onClick={publicar} disabled={!puede}
              style={{ flex: 1, padding: '12px', backgroundColor: puede ? '#DB2777' : '#9CA3AF', color: 'white', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: 'bold', cursor: puede ? 'pointer' : 'not-allowed' }}>
              {publicando ? '⏳ Publicando...' : `📣 Publicar${redes.length === 1 ? ` en ${redes[0] === 'instagram' ? 'Instagram' : 'Facebook'}` : redes.length ? ' en las 2' : ''}`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
